require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/modal");


(function ($) {

    if ($(".section-home").length > 0) {
        require("./page_builder/section_home.es6");
    }

})(jQuery);